module.exports = __webpack_public_path__ + "img/ph-loa.7e324651.jpg";